import React from 'react';
import { Button as PrimeButton } from 'primereact/button';
import styles from './CopyIconButton.module.scss';

/**
 * Copies `value` to the clipboard, falling back to a hidden-textarea +
 * execCommand for browsers/contexts where navigator.clipboard is unavailable.
 * Notification UI is left to the caller via onCopied/onError so this stays
 * usable with any toast/notification system.
 */
const copyToClipboard = async (value) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};

export const CopyIconButton = ({
  value,
  label = 'Value',
  onCopied,
  onError,
}) => {
  if (!value || value === 'N/A') return null;

  const handleCopy = async () => {
    try {
      await copyToClipboard(String(value));
      onCopied?.(label);
    } catch (err) {
      onError?.(err, label);
    }
  };

  return (
    <PrimeButton
      icon="pi pi-copy"
      className={`p-button-text p-button-sm ${styles.copyButton}`}
      onClick={handleCopy}
      tooltip={`Copy ${label}`}
      tooltipOptions={{ position: 'top' }}
      aria-label={`Copy ${label}`}
    />
  );
};
